import axios from 'axios'

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem('jwt_token') || ''}`,
    'Content-Type': 'application/json'
  }
}

export function tagIdsFromRow(row) {
  if (Array.isArray(row?.tagIds) && row.tagIds.length) {
    return row.tagIds.map((id) => Number(id)).filter((id) => id > 0)
  }
  return []
}

export async function bindContentTags(scope, targetId, tagIds) {
  const response = await axios.post(
    '/api/v1/admin/content/tag/bind',
    {
      scope,
      targetId: Number(targetId),
      tagIds: Array.isArray(tagIds) ? tagIds.map((id) => Number(id)).filter((id) => id > 0) : []
    },
    { headers: authHeaders() }
  )
  return response.data
}
